import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  getRetailers,
  resetAdminRetailersState,
} from 'store/admin/retailers';
import { useAppDispatch } from 'hooks';
import { queries, ROWS_PER_PAGES } from 'resources/constants';

const [defaultSize] = ROWS_PER_PAGES;

function useRetailers() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const page: number = Number(searchParams.get(queries.PAGE)) || 0;
  const size: number = Number(searchParams.get(queries.SIZE)) || defaultSize;
  const search: string | null = searchParams.get(queries.SEARCH) || null;
  const status: string | null = searchParams.get(queries.STATUS) || null;

  useEffect(() => () => {
    dispatch(resetAdminRetailersState());
  }, [dispatch]);

  useEffect(
    () => {
      dispatch(getRetailers({
        page,
        size,
        status,
        ...(search ? { search: encodeURIComponent(search) } : {}),
      }));
    },
    [page, size, search, status, dispatch],
  );
}

function useRetailersCallBacks() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const page: number = Number(searchParams.get(queries.PAGE)) || 0;
  const size: number = Number(searchParams.get(queries.SIZE)) || defaultSize;
  const search: string | null = searchParams.get(queries.SEARCH) || null;
  const status: string | null = searchParams.get(queries.STATUS) || null;

  const getRetailersList = useCallback(
    () => dispatch(getRetailers({
      page,
      size,
      status,
      ...(search ? { search: encodeURIComponent(search) } : {}),
    })),
    [dispatch, page, size, status, search],
  );

  return { getRetailersList };
}

export { useRetailers, useRetailersCallBacks };
